import React, { PureComponent } from 'react'
import { Form, Input, Modal,Select} from 'antd'
import moment from 'moment';
import 'moment/locale/zh-cn';
import {baseUrl, reqCountryCityList, reqAddCountry, reqUpdateCountry, reqDeleteCountry, reqAddCity, reqUpdateCity, reqDeleteCity} from '../../api'
moment.locale('zh-cn');
const {Option} = Select;
const formItemLayout = {
    labelCol: {
        span: 6,
    },
    wrapperCol: {
        span: 14,
    },
}
const title={
    add:'新增国家',
    update:'修改国家'
}
class CountryModal extends PureComponent {
    state = {
        country: {}
    }


    handleOk = () => {
        const {onCountryOk} = this.props
        const { validateFields, getFieldsValue, resetFields } = this.props.form
        validateFields((errors,values) => {
            if (errors) {
                return
            }
            const data = {
                ...getFieldsValue(),
            }
            resetFields()
            data.id = this.state.country.id
            onCountryOk(data)
        })
    }
    hideModal = () =>{
        const {onCountryCancel} = this.props
        const {resetFields } = this.props.form
        onCountryCancel()
        resetFields()
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.country) {
            this.setState({
                country: nextProps.country
            })
        }
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const {visible,action} = this.props
        return (
            <Modal  onOk={this.handleOk}
                    title={title[action]}
                    visible={visible}
                    onCancel={this.hideModal}
                    okText="确定"
                    cancelText="取消"
            >
                <Form {...formItemLayout}>
                    <Form.Item label="国家(中文):">
                        {getFieldDecorator('name', {
                            initialValue: this.state.country.name,
                            rules: [{required: true, message: '该项必填'}]
                        })(<Input />)}
                    </Form.Item>
                    <Form.Item label="国家(英文):">
                        {getFieldDecorator('nameEn', {
                            initialValue: this.state.country.nameEn,
                            rules: [{required: true, message: '该项必填'}]
                        })(<Input />)}
                    </Form.Item>
                </Form>
            </Modal>
        )
    }
}
const WrapCountryModal= Form.create()(CountryModal)
export default WrapCountryModal
